module.exports = __webpack_public_path__ + "static/media/paint@2x.11402ee9.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/paint@2x.png
// module id = 893
// module chunks = 0